module.exports = __webpack_public_path__ + "static/media/skywallet_11.24def3be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/skywallet_11.jpg
// module id = 1512
// module chunks = 0